<template>
  <div id="channelManage">
    <el-row class="clearfix" style="margin-bottom: 15px;">
      <el-col class="fl" :span="2"><el-button size="medium" type="success" @click="createClass">新建渠道</el-button></el-col>
      <el-col class="fr" :span="1">
        <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
      </el-col>
      <el-dialog title="新建分类" :visible.sync="dislogCreate" :close-on-click-modal="false" width="500px"@close="emptyDialog('materForm')">
        <el-form ref="materForm" :model="materForm" label-width="100px" :label-position="labelPosition":rules="materFormRules">
          <el-form-item label="渠道名称：" prop="name">
            <el-input v-model.trim="materForm.name"></el-input>
          </el-form-item>
          <el-form-item label="排序:" prop="sort">
            <el-input v-model.trim="materForm.sort"></el-input>
          </el-form-item>
          <el-form-item label="启用状态：" prop="delivery">
            <el-switch v-model="materForm.delivery" :active-value="1"
                       :inactive-value="-1" ></el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit('materForm')">立即创建</el-button>
            <el-button @click="emptyDialog('materForm')">取 消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-row>
    <el-col class="fl" style="width: 17%;">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" :label-position="labelPosition">
        <el-input clearable v-model.trim="searchForm.channelName" placeholder="请输入渠道名称" style="margin-bottom: 15px;"></el-input>
        <el-button type="success" @click="SubmitSearch('searchForm')" style="width: 100%;">检索渠道记录</el-button>
      </el-form>
      <el-button type="text" @click="clearFrom()" class="fr" style="width: 60px;color: #169BD5;">重置</el-button>
    </el-col>
    <el-card class="box-card fr" style="width: 80%;">
      <el-table
        :data="returnData"
        border
        :header-cell-style="{'text-align':'center'}"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="name"
          label="渠道">
        </el-table-column>
        <el-table-column
          align="center"
          prop="sort"
          label="排序">
        </el-table-column>
        <el-table-column
          align="center"
          prop="delivery"
          width="250"
          label="状态">
          <template  slot-scope="scope" :keys="index">
            <span v-if="scope.row.delivery == '1'">启用</span>
            <span v-if="scope.row.delivery == '-1'">禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click.stop="exitBtn(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
  import {
    insertMaterialClassification,selectMaterialClassification,updateMaterialClassification
  } from "../../api/api";
  export default {
    name: 'channelManage',
    data () {
      const validateNumber = (rule, value, callback) => {
        if (/^[1-9]\d*|0$/.test(value) == false) {
          callback(new Error("请输入一个大于0的整数"));
        }else {
          callback();
        }
      }
      return {
        dislogCreate:false,
        labelPosition:'left',
        materForm:{
          name: '',
          sort: '',
          delivery: 1,
        },
        materFormRules:{//validateRoleName
          name: [{ required: true, message: "请输入渠道名称", trigger: "blur" }],
          sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
        },
        searchForm:{
          channelName:'',
        },
        returnData: [
          {
            name: '渠道名称',
            sort: '1',
            delivery: 1,
          },
          {
            name: '渠道名称',
            sort: '2',
            delivery: 1,
          },
          {
            name: '渠道名称',
            sort: '3',
            delivery: 1,
          },
          {
            name: '渠道名称',
            sort: '4',
            delivery: 1,
          },
          {
            name: '渠道名称',
            sort: '5',
            delivery: -1,
          },
          {
            name: '渠道名称',
            sort: '6',
            delivery: 1,
          },
          {
            name: '渠道名称',
            sort: '7',
            delivery: -1,
          },
        ]
      }
    },
    components: {
    },
    mounted () {
      // this.getMaterialClass()
    },
    methods: {
      //清空form
      emptyDialog(formName) {
        this.$refs[formName].resetFields();
        this.dislogCreate = false
      },
      //新建分类
      onSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.returnData.push(
              { name: this.materForm.name,
                number: this.materForm.number,
                delivery:this.materForm.delivery,
              }
            )
          this.dislogCreate = false
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      ///查询物料分类
      getMaterialClass(){
        let para={
          classificationName:this.searchForm.classificationName,
          classificationNumber:this.searchForm.classificationNumber,
        }
        selectMaterialClassification(para).then(res => {
          if (res.data.status==100) {
            // this.supplierList = res.data.results
            console.log(res.data.results)
          }else{
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        }).catch((error) =>{
          this.$Message.error(error.message);
        })
      },
      //新建分类
      createClass() {
        this.dislogCreate = true
      },
      //编辑分类
      exitBtn(index,item) {
        this.canSet = true
        this.dislogCreate = true
        this.dialogMenuStatus = "update";
        this.materForm = Object.assign({}, item);
      },
      //确定保存分类
      saveEventFormSubmitBtn(formname){
        this.$refs[formname].validate((valid) => {
          if (valid) {
            /*获取当前input上输入的文字*/
            let para={
              wasteTreasureId: this.materForm.wasteTreasureId,
              state: this.materForm.state,
            }
            updateWasteTreasure(para).then(res => {
              if (res.status===200) {
                this.$message({
                  message: res.data.message,
                  type: "success"
                });
                /*关闭弹窗，重置输入框*/
                this.dislogCreate = false;
                this.$refs[formname].resetFields();
                /*刷新*/
                this.getWasteTreasureList();
              }
            }).catch((error) =>{
              this.$Message.error(error.message);
            })
          } else {
            console.log('验证未通过');
            return false;
          }
        });
      },
      //清空刷新
      refresh() {
        this.getMaterialClass()
      },

      //确认检索
      SubmitSearch() {
        this.getMaterialClass()
      },
      clearFrom(){
        this.searchForm = {}
      }
    },
    computed: {
    },
    watch: {
      
    }
  }
</script>

<style lang="scss" type="text/css">
  /*@import './assets/css/gome.base.css';*/
  /*@import '../node_modules/iview/dist/styles/iview.css';*/
</style>



// WEBPACK FOOTER //
// channelManage.vue?5b4bdd80